document.addEventListener('DOMContentLoaded', function () {
  const selectedEl = document.getElementById('selected-fragrance');
  if (!selectedEl) return;

  function getOptionTexts() {
    const values = [];
    document.querySelectorAll('select[name^="options"]').forEach(sel => {
      if (sel.selectedIndex >= 0) values.push(sel.options[sel.selectedIndex].text.trim());
    });
    document.querySelectorAll('input[type="radio"]:checked').forEach(r => {
      const lbl = r.closest('label');
      values.push((lbl ? lbl.textContent : r.value).trim());
    });
    return values.filter(Boolean).join(' ');
  }

  function updateTitle() {
    const txt = getOptionTexts();
    selectedEl.textContent = txt ? ' ' + txt : '';
  }

  document.addEventListener('change', updateTitle, true);
  document.addEventListener('click', function(){ setTimeout(updateTitle, 50); }, true);

  setTimeout(updateTitle, 60);
});

